export var SCHEMA_TYPES = {
    LOCAL_BUSINESS: 'static-page-local-business',
    SITE_SEARCH: 'static-page-site-search',
};
